/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Standards_Preset_Save_ConfirmInputs */



/**
* | output |
* | --- |
* | "Save" |
*
* @param {Standards_Preset_Save_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const standards_preset_save_confirm = /** @type {((inputs?: Standards_Preset_Save_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Standards_Preset_Save_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Save")
	if (locale === "de") return /** @type {LocalizedString} */ ("Save")
	if (locale === "it") return /** @type {LocalizedString} */ ("Save")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Save")
	if (locale === "es") return /** @type {LocalizedString} */ ("Save")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Save")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Save")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Save")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Save")
	return /** @type {LocalizedString} */ ("Save")
});